module.exports = __webpack_public_path__ + "img/select-01.5f201d23.svg";